import BaseService from '../base.service';

export class OrderService {
  // 创建订单
  static async createOrderApi(data) {
    return BaseService.post('/web/order', data);
  }

  // 根据订单id来查询订单信息
  static async getOrderByIdApi(id) {
    return await BaseService.get(`/web/order/${id}`);
  }

  // 分页获取订单列表数据
  static async getOrderListApi(params) {
    return await BaseService.get('/web/order/orderList', params);
  }

  // 根据订单id获取订单详情
  static async getOrderDetailsApi(id) {
    return await BaseService.get(`/web/order/orderDetail/${id}`);
  }
}
